<template>
  <v-container fluid>
    <v-row>
      <v-col class="pt-0">
        <v-progress-linear
          indeterminate
          height="2"
          v-if="fetching"
        ></v-progress-linear>
        <template v-else-if="task">
          <v-row>
            <v-col
              cols="12"
              md="8"
              lg="9"
            >
              <general-details
                :type="taskType"
                :task="task"
                :isCompleted="isCompleted"
              />
              <notes
                :parentId="task._id"
                :parentType="'task'"
                :add="createNote"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
              lg="3"
            >

              <v-card flat>
                <v-toolbar
                  dense
                  flat
                >
                  <v-toolbar-title>פעולות</v-toolbar-title>
                </v-toolbar>
                <v-divider />
                <v-list nav>
                  <template v-for="(item) in actionsMenu">
                    <v-list-item
                      :key="item.title"
                      @click="envokeMethodByName(item.action)"
                      v-if="item.viewIf ? propertByName(item.viewIf) : true"
                      class="ma-0"
                    >
                      <v-list-item-avatar>
                        <v-progress-circular
                          indeterminate
                          :size="20"
                          :width="2"
                          color="primary"
                          v-if="propertByName(item.loading) || false"
                        ></v-progress-circular>
                        <v-icon
                          v-else
                          :color="item.color"
                        >{{ item.icon }}</v-icon>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title><span :class="`${item.color}--text`">{{ item.title }}</span></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </template>
        <v-alert
          :value="true"
          color="white"
          class="grey--text"
          icon="mdi-information-outline"
          v-else
        >
          נתוני משימה לא נמצאו. נסו לטעון את הדף מחדש
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Notes from "@/components/notes/Notes";
import GeneralDetails from "@/components/tasks/GeneralDetails";
import { format } from "date-fns";
import generateId from "@/idGenerator";
import { getApi } from "@/api";

export default {
  data() {
    return {
      tab: null,
      fetching: true,
      removing: false,
      settingAsCompleted: false,
      actionsMenu: [
        {
          icon: "mdi-checkbox-blank-outline",
          color: "primary",
          title: "סימון כמבוצעת",
          action: "setAsCompleted",
          loading: "settingAsCompleted",
          viewIf: "isNotCompleted"
        },
        {
          icon: "mdi-check-box-outline",
          color: "primary",
          title: "ביטול סימון ביצוע",
          action: "setAsNotCompleted",
          loading: "settingAsCompleted",
          viewIf: "isCompleted"
        },
        // {
        //   icon: "mdi-comment-plus",
        //   color: "primary",
        //   title: "הוספת הערה",
        //   action: "createNote"
        // },
        {
          icon: "mdi-pencil",
          color: "primary",
          title: "עריכת פרטים",
          action: "edit"
        },
        {
          icon: "mdi-delete",
          color: "red",
          title: "מחיקה",
          action: "remove",
          loading: "removing"
        }
      ]
    };
  },
  computed: {
    user() {
      return this.$store.getters["user/user"];
    },
    taskId() {
      return this.$route.params.id;
    },
    task() {
      return this.$store.getters["entity"]("tasks", this.taskId);
    },
    taskType() {
      let type = this.task.type;
      if (type) {
        return this.$store.getters["entity"]("taskTypes", type);
      }
      return null;
    },
    isCompleted() {
      return !!this.task.completedBy && !!this.task.completionDate;
    },
    isNotCompleted() {
      return !this.isCompleted;
    },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    }
  },
  methods: {
    format,
    propertByName(name) {
      return this[name];
    },
    envokeMethodByName(name) {
      this[name]();
    },
    setAsCompleted() {
      this.settingAsCompleted = true;
      getApi()
        .then(api => {
          return api.post(`/tasks/${this.taskId}/set-as-completed`);
        })
        .catch(err => {
          console.log(err);
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.settingAsCompleted = false;
        });
    },
    setAsNotCompleted() {
      this.settingAsCompleted = true;
      getApi()
        .then(api => {
          return api.post(`/tasks/${this.taskId}/set-as-not-completed`);
        })
        .catch(err => {
          console.log(err);
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.settingAsCompleted = false;
        });
    },
    edit() {
      this.editTask(this.task);
    },
    remove() {
      this.$root.$confirm("האם למחוק את המשימה?").then(res => {
        if (!res) {
          return;
        }

        let id = this.task._id;

        this.removing = true;
        this.$store
          .dispatch("REMOVE_ENTITY", {
            url: "/tasks",
            entityType: "tasks",
            id
          })
          .then(() => {
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: "הפריט נמחק",
              color: "success"
            });
            this.$router.go(-1);
          })
          .catch(err => {
            console.log(err.stack);
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: err.message,
              color: "error"
            });
          })
          .finally(() => {
            this.removing = false;
          });
      });
    },
    editTask(entity, isNew = false) {
      let resource = this.$store.state.resources.task;
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: resource.schema
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource,
        isNew
      });
      this.entityEditDialog = true;
    },
    fetch() {
      this.fetching = true;
      this.$store
        .dispatch("API_GET", {
          url: "/tasks/" + this.taskId,
          entityType: "tasks",
          schema: "taskListSchema"
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    createNote() {
      let newEntity = {
        _id: generateId(),
        task: this.task._id,
        user: this.user._id
      };
      this.editNote(newEntity, true);
    },
    editNote(entity, isNew = false) {
      let resource = this.$store.state.resources.note;
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: resource.schema
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource,
        isNew
      });
      this.entityEditDialog = true;
    }
  },
  mounted() {
    this.fetch();
  },
  watch: {},
  components: {
    GeneralDetails,
    Notes
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
